module.exports = __webpack_public_path__ + "static/media/thunder-solution.9e631d62.svg";